module.exports = __webpack_public_path__ + "static/bluesky-5950a3071f3a9943dfe53a04074c5bb1.png";